<template>
<div>
  <el-card shadow="never">
    <div slot="header">
      <span>分红开关</span>
    </div>
    <div>
      <el-table
        :data="shareSwitchList">
        <el-table-column
          prop="name"
          label="开关名称">
        </el-table-column>
        <el-table-column
          prop="switchKey"
          label="KEY">
        </el-table-column>
        <el-table-column
          label="状态">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.status"
              active-color="#13ce66"
              @change="handleSwitchChange(scope.row.switchKey, $event)"
            >
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
  <el-card shadow="never">
    <div slot="header">
      分红子开关
    </div>
    <div>
      <el-form :inline="true" :model="shareChildSwitchForm" ref="shareChildSwitchForm">
        <el-form-item label="分红时间：">
          <el-date-picker type="date" placeholder="选择日期" v-model="shareChildSwitchForm.shareTime"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleGetShareChildSwitch">查询</el-button>
        </el-form-item>
      </el-form>
      <div>
        当前开关分红时间：<el-tag type="info" style="margin-right: 10px;">{{ shareTime | moment('YYYY-MM-DD')}}</el-tag>
        开关状态：
        <el-switch
          :value="shareChildSwitch"
          @change="handleChildSwitchChange"
          active-color="#13ce66"
        ></el-switch>
      </div>
    </div>
  </el-card>
</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'ShareSwitch',
  data() {
    return {
      shareChildSwitchForm: {},
      shareTime: null
    };
  },
  computed: {
    ...mapGetters('miningShare', ['shareSwitchList']),
    ...mapState('miningShare', ['shareChildSwitch'])
  },
  methods: {
    ...mapActions('miningShare', [
      'getShareSwitchList',
      'turnOnSwitch',
      'turnOffSwitch',
      'getShareChildSwitch',
      'turnOnChildSwitch',
      'turnOffChildSwitch'
    ]),
    handleSwitchChange(key, status) {
      const action = status ? this.turnOnSwitch : this.turnOffSwitch;

      this.$confirm('确认要进行此操作吗？', '提示', { type: 'warning' }).then(
        () => {
          action(key).then(() => {
            this.$message.success('操作成功！');
            this.getShareSwitchList();
          });
        }
      );
    },
    handleGetShareChildSwitch() {
      this.getShareChildSwitch(this.shareChildSwitchForm).then(() => {
        this.shareTime = this.shareChildSwitchForm.shareTime || moment();
      });
    },
    handleChildSwitchChange(status) {
      if (status) {
        this.$prompt('请输入有效时间', '打开开关', { inputType: 'datetime-local' }).then(
          ({ value }) => {
            this.turnOnChildSwitch({
              shareTime: this.shareTime,
              validTime: moment(value).valueOf()
            }).then(({ data }) => {
              const { des, shareCount } = data;

              this.$alert(`${des}，shareCount：${shareCount}`, '结果', {
                type: 'info'
              });
              this.refreshShareChildSwitch();
            });
          }
        );
      } else {
        this.$confirm('确认要关闭开关吗？', '提示', { type: 'warning' }).then(
          () => {
            this.turnOffChildSwitch({ shareTime: this.shareTime }).then(
              ({ data }) => {
                const { des } = data;

                this.$alert(des, '结果', {
                  type: 'info'
                });
                this.refreshShareChildSwitch();
              }
            );
          }
        );
      }
    },
    refreshShareChildSwitch() {
      this.getShareChildSwitch({ shareTime: this.shareTime });
    }
  },
  created() {
    this.getShareSwitchList();
    this.handleGetShareChildSwitch();
  }
};
</script>

<style lang="less" scoped>
.el-card + .el-card {
  margin-top: 20px;
}
</style>
